import { render, staticRenderFns } from "./printShippingLabel.vue?vue&type=template&id=548eb94d&"
import script from "./printShippingLabel.vue?vue&type=script&lang=js&"
export * from "./printShippingLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports